import React, { useState } from "react";
import { Redirect } from 'react-router-dom';

import { makeStyles } from "@material-ui/core/styles";

import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import logo from "assets/img/logoSt.png";
import useAuth from "hooks/useAuth";
import SomeSpinner from "components/Somespinner/Somespinner";
import 'bootstrap/dist/css/bootstrap.min.css';

const styles = {
  overflowNone: {
    overflow: "Unset"
  },
  margintp: {
    margin: "45px 0 0 0"
  },
  margintpbox: {
    margin: "13vh 0 0 0"
  }
};

const useStyles = makeStyles(styles);


const SignIn = () => {


  const { signed, signIn, storageUserType, loading } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  const handleSignIn = () => {

    signIn(username, password);
  };
  const classes = useStyles();


  if (loading) {
    return (
      <div>
        <SomeSpinner />
      </div>
    )
  }

  const redirectPath = () => {
    let path = './' + storageUserType + '/order'
    switch (storageUserType) {
      case 'admin':
        path = './' + storageUserType + '/dashboard'
        break;
      case 'operator':
        path = './' + storageUserType + '/table'
        break;
      case 'sellsman':
        path = './' + storageUserType + '/order'
        break;
      case 'deliveryman':
        path = './' + storageUserType + '/dashboard'
        break;
      default:
        break;
    }
    return path;
  }
  return (
    <div>
      {signed ? (
        <Redirect to={redirectPath()} />
      ) : (

        <div className="d-flex justify-content-center">
          <div className={classes.margintpbox}>
            <GridContainer style={{ justifyContent: "center" }}>
              <GridItem xs={12} sm={12} md={8}>
                <Card profile>
                  <CardAvatar className={classes.overflowNone} profile>
                    <img src={logo} alt="..." />
                  </CardAvatar>
                  <form onSubmit={handleSignIn}>
                    <CardBody profile>
                      <GridContainer>
                        <GridItem xs={12}>
                          <CustomInput
                            type="text"
                            labelText="Login"
                            id="username"
                            formControlProps={{
                              fullWidth: false,
                            }}
                            inputProps={{
                              value: username,
                              onChange: event => setUsername(event.target.value)
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} >
                          <CustomInput
                            labelText="Senha"
                            id="password"
                            formControlProps={{
                              fullWidth: false,
                            }}
                            inputProps={{
                              type: "password",
                              value: password,
                              onChange: event => setPassword(event.target.value)
                            }}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridItem xs={12}>
                        <Button className={classes.margintp} type="submit">
                          Acessar
                        </Button>
                      </GridItem>
                    </CardBody>
                  </form>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      )}
    </div>
  )
};

export default SignIn;